import Link from 'next/link'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Typography from '@/components/base/Typography'

import { WPImage } from '@/types'

type MoodGridProps = {
  items: {
    image?: WPImage
    title: string
    subtitle?: string
    link: string
  }[]
}

const MoodGrid = ({ items }: MoodGridProps) => (
  <section className="bg-dark-100 py-[6rem] text-dark-500 lg:py-[12rem]">
    <Container>
      <Grid className="gap-y-[4rem]">
        {items.map((item) => (
          <Link
            key={item.link}
            href={item.link}
            scroll={false}
            className="group col-span-4 md:col-span-3 lg:col-span-6"
          >
            {item.image?.url && (
              <div className="relative aspect-[4/3] overflow-hidden">
                <Image
                  source={item.image}
                  fill
                  fit="cover"
                  className="transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
            )}
            <Typography
              component="h2"
              variant="h3"
              className="mt-[1.6rem] block"
            >
              {item.title}
            </Typography>
            {item.subtitle && (
              <Typography component="p" variant="label" className="block">
                {item.subtitle}
              </Typography>
            )}
          </Link>
        ))}
      </Grid>
    </Container>
  </section>
)

export default MoodGrid
